module.exports = __webpack_public_path__ + "img/video-bg3.fe70a1db.jpg";